import React from "react"
import DocViewer, { DocViewerRenderers } from "react-doc-viewer"
import { LocalStorage } from "@Techedge/digitalportal-shared"

//CSS per abilitare i link dentro i pdf. Commentato perchè vengono aperti nella stessa tab dell'app
//import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

type Props = {
    src: string
    className?: string
    header?: JSX.Element
}

const EXTENTIONS_FOR_VIDEOS = ["mp4", "mkv", "mov"]
const EXTENTIONS_FOR_DEFAULT_IFRAME = ["pdf", "xls", "xlsx"]
const EXTENTIONS_FOR_IMAGES = ["png", "jpg", "jpeg", "gif"]

export const getFileExtention = (fileName: string) => {
    if (!fileName) {
        return {
            ext: null,
            name: null,
        }
    }
    let ext = fileName.split(".").pop()
    let name = fileName.replace("." + ext, "")
    return { ext, name }
}

export default class LazyDocumentPreview extends React.Component<Props, { hasError: boolean }> {
    constructor(props: any) {
        super(props)
        this.state = {
            hasError: false,
        }
    }

    componentDidCatch() {
        this.setState({ hasError: true })
    }

    render() {
        if (this.state.hasError) {
            return (
                <DocumentPreviewCompatibility
                    src={this.props.src}
                    className={this.props.className}
                    header={this.props.header}
                />
            )
        } else {
            return (
                <DocumentPreviewAdvanced
                    src={this.props.src}
                    className={`attachment-preview ${this.props.className}`}
                    header={this.props.header}
                />
            )
        }
    }
}

export const DocumentPreviewAdvanced = (props: any) => {
    const { ext } = getFileExtention(props?.fileName)

    const useVideoEmbedding = EXTENTIONS_FOR_VIDEOS.includes(ext?.toLocaleLowerCase())
    const useImageEmbedding = EXTENTIONS_FOR_IMAGES.includes(ext?.toLocaleLowerCase())

    if (useVideoEmbedding) {
        return (
            <video
                src={`${props?.fileUrl}`}
                width="100%"
                controls
                className={"document-previewer" + props?.className}
            />
        )
    } else if (useImageEmbedding) {
        return (
            <div>
                {props?.header}
                <img src={props?.fileUrl} style={{ maxWidth: "100%", height: "auto" }} />
            </div>
        )
    } else {
        return (
            <DocViewer
                className={props?.className}
                pluginRenderers={DocViewerRenderers}
                config={{
                    header: {
                        // disableFileName: true
                        disableHeader: props?.header == null,
                        overrideComponent: () => props?.header,
                    },
                }}
                documents={[{ uri: props?.fileUrl }]}
                // requestHeaders={
                //     props?.fileUrl.indexOf('splitfile') > -1
                //         ? { Authorization: 'Bearer ' + LocalStorage.getAccessToken() }
                //         : {}
                // }
            />
        )
    }
}

export const DocumentPreviewCompatibility = (props: any) => {
    const { ext } = getFileExtention(props?.src?.fileName)

    const useDefaultIframe = EXTENTIONS_FOR_DEFAULT_IFRAME.includes(ext?.toLocaleLowerCase())
    const useImageEmbedding = EXTENTIONS_FOR_IMAGES.includes(ext?.toLocaleLowerCase())
    const useVideoEmbedding = EXTENTIONS_FOR_VIDEOS.includes(ext?.toLocaleLowerCase())

    let DovViewer: any
    if (useVideoEmbedding) {
        DovViewer = (
            <video
                src={`${props?.fileUrl}`}
                width="100%"
                controls
                className={"document-previewer" + props?.className}
            />
        )
    } else if (useImageEmbedding) {
        DovViewer = <img src={props?.fileUrl} style={{ maxWidth: "100%", height: "auto" }} />
    } else if (useDefaultIframe) {
        // embedding pdf on mobile devices works very bad for ipads
        DovViewer = (
            <iframe
                src={`${props?.fileUrl}?&embedded=true`}
                height="100%"
                width="100%"
                frameBorder="0"
                allow="fullscreen"
                className={"document-previewer" + props?.className}
            />
        )
    } else {
        DovViewer = (
            <iframe
                src={`http://docs.google.com/viewer?pid=explorer&efh=false&a=v&chrome=false&embedded=true&url=${props?.fileUrl}`}
                height="100%"
                width="100%"
                frameBorder="0"
                allow="fullscreen"
                className={"document-previewer" + props?.className}
            />
        )
    }

    return (
        <>
            {props?.header}
            {DovViewer}
        </>
    )
}
